// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__2gHgT","badge-sm":"Badge_badge-sm__1P3b1","badge-md":"Badge_badge-md__3BTM1"};